export default function CapsCategoryFilters({
  filters,
  value,
  onChange,
}) {
  return (
    <div
      className="flex gap-2 overflow-x-auto pb-1 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
      role="group"
      aria-label="Filter caps"
    >
      {filters.map((filter) => {
        const active = value === filter.value;

        return (
          <button
            key={filter.value}
            type="button"
            onClick={() => onChange(filter.value)}
            aria-pressed={active}
            className={`min-h-10 shrink-0 rounded-full border px-4 py-2 text-xs font-black uppercase tracking-wide transition focus:outline-none focus:ring-2 focus:ring-neutral-950 focus:ring-offset-2 ${
              active
                ? "border-neutral-950 bg-neutral-950 text-white"
                : "border-border bg-white text-muted-foreground hover:border-neutral-950 hover:text-neutral-950"
            }`}
          >
            {filter.label}
          </button>
        );
      })}
    </div>
  );
}